export default ({ request }) => ({
  customerQuotationListApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/list',
      method: 'POST',
      data,
    })
  },
  customerQuotationDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/detail',
      method: 'POST',
      data,
    })
  },
  customerQuotationSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/save',
      method: 'POST',
      data,
    })
  },
  customerQuotationDelApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/del',
      method: 'POST',
      data,
    })
  },
  customerQuotationAuditApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/audit',
      method: 'POST',
      data,
    })
  },
  customerQuotationSampleListApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/sample/list',
      method: 'POST',
      data,
    })
  },
  customerQuotationSampleOptionsApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/sample/options',
      method: 'POST',
      data,
    })
  },
  customerQuotationSampleAddApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/sample/add',
      method: 'POST',
      data,
    })
  },
  customerQuotationSampleDelApi(data) {
    return request({
      url: '/digitalCenter/customer/quotation/sample/del',
      method: 'POST',
      data,
    })
  },
})
